<template>
  <div>
    <w-vue-select
      label-field="name"
      value-field="name"
      :model="schoolModel.selectedSchoolName"
      :values="options"
      :ajax="!isSecretary"
      :taggable="!isSecretary"
      @input="checkIfDeprecated"
      @search="search"
    />

    <span v-if="schoolModel.deprecated.$model">
      Wniosek zostanie przekazany do szkoły {{ schoolModel.schoolName.$model }}.
    </span>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import components from '@witkac/bootstrap4-components/src/components/formComponents';

import { PublicSettings } from '@/enums/publicSettings.enum';
import { schoolPickerSecretaryMixin } from '@/mixins/schoolPickerSecretary';
import { schoolPickerChildsOnlyMixin } from '@/mixins/document/schoolPickerChildsOnly';

// @vuese
// Wybierak szkoły do duplikatów
// @group Forms
export default {
  components,
  mixins: [schoolPickerSecretaryMixin, schoolPickerChildsOnlyMixin],
  computed: mapState({
    mapping: state =>
      JSON.parse(
        (state.setting.settings[PublicSettings.OLD_STRUCTURE_NODE_MAPPING] &&
          state.setting.settings[PublicSettings.OLD_STRUCTURE_NODE_MAPPING].value) ||
          '[]'
      ).map(map => {
        map.deprecated = true;
        return map;
      })
  }),
  methods: {
    // @vuese
    // Dodaje wyniki z ustawienia mapowania do wyników wyszukiwania
    processSearchResult(list) {
      return [...list, ...this.mapping];
    },
    // @vuese
    // Sprawdza czy szkoła nie została przekształcona w inną szkołę
    checkIfDeprecated(selectedSchool) {
      this.schoolModel.deprecated.$setData(selectedSchool.deprecated || false);

      if (selectedSchool.deprecated) {
        this.$store
          .dispatch('structureNode/get', selectedSchool.currentNodeId)
          .then(structureNode => this.updateSchoolData(structureNode));
      } else {
        this.updateSchoolData(selectedSchool);
      }
    }
  }
};
</script>
